import React from "react";
import { About } from "../common";

export const AboutJitter = (props) => {
  return (
    <>
      <div className={props.className}>
        <About id='about-jitter'>
          Jitter or packet delay variance is the fluctuation in delay as packets transfer across a network.
        </About>
      </div>
    </>
  );
};
